import { render, staticRenderFns } from "./CoordinatorBlackIcon.vue?vue&type=template&id=ccbb7168&"
import script from "./CoordinatorBlackIcon.vue?vue&type=script&lang=js&"
export * from "./CoordinatorBlackIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports